import script from "./MobileHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileHomePage.vue?vue&type=script&setup=true&lang=js"

import "./MobileHomePage.vue?vue&type=style&index=0&id=285b717f&lang=css"

const __exports__ = script;

export default __exports__